import React, { useEffect } from "react";
import { SectionContentProps } from "../../types";
import FAQAccordion from "./FAQAccordion";
import FAQGrid from "./FAQGrid";
import { FAQUniversity } from "../../university";
import { HokFaq } from "../../hok";
import OvanFaq from "../../ovan/ovanfaq/OvanFaq";

export default function FAQSection(props: SectionContentProps) {
    const { content, onContentChange } = props;
    const variant = content.variant || "v1";

    useEffect(() => {
        if (!content.items || content.items.length === 0) {
            onContentChange?.({
                ...content,
                title: "Common Inquiries",
                subtitle: "Everything you need to know about the product and billing.",
                items: [
                    { q: "What is your refund policy?", a: "We offer a 30-day money-back guarantee no questions asked." },
                    { q: "Do you offer technical support?", a: "Yes, our team is available 24/7 to assist you with any issues." },
                    { q: "Can I cancel my subscription?", a: "Absolutely. You can cancel anytime from your account settings." }
                ]
            });
        }
    }, []);

    if (variant === "ovan") {
        return <OvanFaq {...props} />;
    }

    if (variant === "v3" || variant === "faq-v3" || variant === "university-faq") {
        return <FAQUniversity {...props} />;
    }

    if (variant === "v2" || variant === "faq-v2") {
        return <FAQGrid {...props} />;
    }

    if (variant === "hok" || variant === "faq-hok") {
        return <HokFaq {...props} />;
    }

    return <FAQAccordion {...props} />;
}

